function init() {

  const skipButton = document.querySelector("#skip-button") as HTMLElement;
  const sections = document.querySelectorAll(
    ".main-container > *"
  ) as NodeListOf<HTMLElement>;
  const footer = document.querySelector(".c-footer");

  if (skipButton && sections.length > 0) {
    let currentSectionIndex = 0;

    const updateButtonLink = () => {
      if (currentSectionIndex < sections.length - 1) {
        skipButton.classList.remove("top");
        skipButton.classList.add("next");
        skipButton.setAttribute("aria-label", "Skip to next section");
        skipButton.onclick = () =>
          sections[currentSectionIndex + 1].scrollIntoView({
            behavior: "smooth",
          });
      } else {
        skipButton.classList.remove("next");
        skipButton.classList.add("top");
        skipButton.setAttribute("aria-label", "Skip to top");
        skipButton.onclick = () =>
          sections[0].scrollIntoView({ behavior: "smooth" });
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            currentSectionIndex = Array.from(sections).indexOf(
              entry.target as HTMLElement
            );
            updateButtonLink();
          }
        });
      },
      { threshold: 0.5 }
    );

    sections.forEach((section) => observer.observe(section));
    updateButtonLink();

    if (footer) {
      const defaultBottom = 48;
      const setButtonOffset = () => {
        const footerBounds = footer.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        if (footerBounds.top < windowHeight && footerBounds.top > 0) {
          const overlap = windowHeight - footerBounds.top;
          skipButton.style.bottom = `${defaultBottom + overlap}px`;
        } else if (footerBounds.top <= 0) {
          skipButton.style.bottom = `${defaultBottom + footerBounds.height}px`;
        } else {
          skipButton.style.bottom = `${defaultBottom}px`;
        }
      };

      window.addEventListener("scroll", setButtonOffset);
      window.addEventListener("resize", setButtonOffset);
      setButtonOffset();
    }
  }
}

export default init;
